{
	"importSuccessNotification": "Plano de contas importado com sucesso.",
	"onChangeSuccessNotification": "Arquivo {{name}} enviado com sucesso",
	"errorNotification": "Envio do arquivo {{name}} falhou",
	"deleteSuccessNotification": "Plano de contas apagado.",
	"showTree": "Visualizar árvore do plano de contas",
	"export": "Exportar Planilha",
	"delete": "Apagar Plano de Contas",
	"enter": "enter",
	"esc": "esc",
	"showTreeTitle": "Árvore do plano de contas",
	"deleteConfirmDialog": "Tem certeza que deseja apagar o plano de contas?",
	"downloadTemplate": "Baixar Planilha Modelo",
	"chooseName": "Escolha um nome!",
	"existingName": "Nome já existente",
	"createNewAccount": "Criar nova conta",
	"createSuggestedPlan": "Usar plano de contas sugerido",
	"deleteBillPlanSuccessNotification": "Conta {{name}} apagada com sucesso",
	"deleteBillPlanConfirmDialog": "Tem certeza que deseja deletar a conta \"{{name}}\"?",
	"hasBillsMessage": "Essa conta já possui transações associadas a ela.",
	"editPlanOfAccountsSuccess": "Plano de contas editado com sucesso.",
	"name": "Nome",
	"parent": "Pai da categoria",
	"parentPlaceholder": "Selecionar um novo pai..."
}
